// @flow
import { CUSTOMIZE } from 'pages/MyAccount/services/actions/customizeActions';
import type { Action } from 'pages/MyAccount/services/actions/Action.type';

export type ExperimentInfo = {|
  +qualified: boolean,
  +variation: string,
|};
export type CustomizeState = {|
  +lastQuestionId: string | null,
  +fetchingLastQuestionId: boolean,
  +experimentInfo: ExperimentInfo,
|};

export const customizeInitialState = {
  lastQuestionId: null,
  fetchingLastQuestionId: false,
  experimentInfo: {
    qualified: false,
    variation: 'CONTROL',
  },
};

export function customizeReducer(
  state: CustomizeState = customizeInitialState,
  action: Action
): CustomizeState {
  switch (action.type) {
    case CUSTOMIZE.REQUEST_LAST_QUESTION: {
      return {
        ...state,
        fetchingLastQuestionId: true,
      };
    }
    case CUSTOMIZE.RECEIVE_LAST_QUESTION_SUCCESS: {
      return {
        ...state,
        fetchingLastQuestionId: false,
        lastQuestionId: action.lastQuestionId,
        experimentInfo: action.experimentInfo,
      };
    }
    case CUSTOMIZE.RECEIVE_LAST_QUESTION_ERROR: {
      return {
        ...state,
        fetchingLastQuestionId: false,
        error: action.error,
      };
    }
    default: {
      return state;
    }
  }
}

export default customizeReducer;
